import {
  ChangeVideoCommentPosition,
  INetworkConfig,
  IPagination,
  IResponse,
  ISuccessResponse,
  IUploadVideo,
  IVideoComment,
  IVideoComments,
  LanguageAlphabet,
  OnUploadProgressType,
} from '@/types'
import { IAddVideoCommentSend, IEditVideoCommentCall } from '@/types/videoComments'
import { Endpoints } from '../endpoints'
import { Instance } from '../instance'

const config: INetworkConfig = {
  baseURL: Endpoints.Base,
}

class VideoComments extends Instance {
  constructor(config: INetworkConfig) {
    super(config)
  }

  getVideoComments = (params: IPagination): Promise<IResponse<IVideoComments>> =>
    this.get(Endpoints.VideoComments, { params })

  getVideoCommentById = (id: number, language?: LanguageAlphabet): Promise<IResponse<IVideoComment>> =>
    this.get(`${Endpoints.VideoComments}/${id}`, language ? { headers: { language } } : undefined)

  uploadVideoComment = (params: FormData, onUploadProgress: OnUploadProgressType): Promise<IResponse<IUploadVideo[]>> =>
    this.post(Endpoints.UploadVideo, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    })

  addVideoComment = (params: IAddVideoCommentSend): Promise<IResponse<ISuccessResponse>> =>
    this.post(Endpoints.VideoComments, params)

  editVideoComment = (params: IEditVideoCommentCall): Promise<IResponse<ISuccessResponse>> =>
    this.put(`${Endpoints.VideoComments}/${params?.id}`, params)

  deleteVideoComments = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.delete(`${Endpoints.VideoComments}/${id}`)

  editVideoCommentPosition = (params: ChangeVideoCommentPosition[]): Promise<IResponse<ISuccessResponse>> =>
    this.put(Endpoints.UpdatedVideoCommentPosition, params)
}

export const videoCommentsApi = new VideoComments(config)
